import React, { useState } from 'react'
import {Container,Row,Col,Button,Form} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from "../../context/auth/useAuth"

const clientCredentials = {};

export default function Login() {    
    const { t } = useTranslation()    
    const [islogging, setIslogging] = useState(false)
    const {loginClient} = useAuth();

    const handleSubmit = async(e) => {
        e.preventDefault()        
        setIslogging(true)   
        loginClient(clientCredentials)
    }

    return (
    <>
        
        <Container className='cuerpo'>
            <Row>
                <Col className="text-center mt-2">
                <img
                    src="/images/logotipo.png"
                    className="d-inline-block align-top justify-center"
                    alt="Logotipo SD Agro"
                    id="logo-menu"
                />
                </Col>
            </Row>
            <Row>
                <Col className="d-flex justify-content-center mt-5">
                    <Form className="form p-4" onSubmit={ handleSubmit} id="login">
                        <Row className="text-left custom-card-header">
                            <h1>{t('signin.bienvenida')}</h1>
                            <Form.Label className="form-label">{t('signin.signin')}</Form.Label>
                        </Row>
                        <Row className="text-center custom-card-body">
                            <div className="fv-row mb-10">
                                <i className="fas fa-user custom-fas custom-fas-form-control"></i><Form.Control placeholder={t('signin.username')} name="login_username" className="form-control-lg form-control-solid custom-form-control" type="text" autoComplete="off" onChange={ (e) => clientCredentials.username = e.target.value} />
                            </div>
                            <div className="fv-row my-4">
                                <i className="fas fa-key custom-fas custom-fas-form-control"></i><Form.Control placeholder={t('signin.password')} type="password" autoComplete="off" name="login_password" className="form-control-lg form-control-solid custom-form-control" onChange={ (e) => clientCredentials.password = e.target.value} />
                            </div>
                        </Row>
                        <Row className="custom-card-buttom py-5">
                            <Button variant='primary' type="submit" className="btn-sm my-2 mx-auto">
                            {islogging
                                ?
                                <span className="indicator-label">
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                                :
                                <span className="indicator-label">{t('signin.acceder')}</span>
                            }
                            </Button>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Container>
    </>
    )
}
